import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { EVENTS_API } from '../api/events-api';
import { EventId, EventViewInterface } from '../types/event-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
export function useEvent(id) {
  const $ = _c(8);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: eventFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== id || $[2] !== user) {
    t1 = () => {
      if (user) {
        return [`${EVENTS_API}/${id}`, RequestModuleEnum.Calendar];
      }
    };
    $[1] = id;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: eventData,
    mutate,
    isLoading
  } = useControlledSwr(t1, eventFetcher);
  let t2;
  if ($[4] !== eventData || $[5] !== isLoading || $[6] !== mutate) {
    t2 = {
      eventData,
      mutate,
      isLoading
    };
    $[4] = eventData;
    $[5] = isLoading;
    $[6] = mutate;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}